import { render, staticRenderFns } from "./ConfirmationPopup.vue?vue&type=template&id=12f2b4f0&scoped=true&"
import script from "./ConfirmationPopup.vue?vue&type=script&lang=ts&"
export * from "./ConfirmationPopup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12f2b4f0",
  null
  
)

export default component.exports